import axios from 'axios';
import cookieManager from '@/utils/cookieManager';

import router from './router';

let isRefreshing = false;
let failedQueue = [];

// axios.defaults.withCredentials = true;

const processQueue = (error, token = null) => {
  // console.log(`Processing queue. Error: ${error}, Token: ${token}, Queue: ${failedQueue.length}`);
  // eslint-disable-next-line
  failedQueue.forEach((prom, index) => {
    if (error) {
      // console.log(`Rejecting promise in posición ${index} due to an error.`);
      prom.reject(error);
    } else {
      // console.log(`Resolving promise in queue in posicition ${index} with token: ${token}`);
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

const logout = () => {
  cookieManager.deleteAll();
  router.push({ name: 'Start' });
};

axios.interceptors.response.use(
  response => response,
  error => {
    const originalRequest = error.config;
    // console.log(`Interceptor de respuesta. Error: ${error.response.status}, isRefreshing: ${isRefreshing}`);

    if (originalRequest?.headers?.ignoreRefreshToken) {
      // Opt out of the refresh dance and let the caller handle its own 401.
      return Promise.reject(error);
    }
    if (error.response?.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        // console.log('Adding a failedQueue because we are already refreshing the token.');
        return new Promise(function(resolve, reject) {
          failedQueue.push({
            resolve: token => {
              // console.log('push failedQueue', token);
              originalRequest.headers['Authorization'] = `Bearer ${token}`;
              resolve(axios(originalRequest));
            },
            reject: err => {
              // console.log('rejech failedQueue', err);
              reject(err);
            }
          });
        });
      }
      // console.log('Init refreshing token.');
      originalRequest._retry = true;
      isRefreshing = true;

      return new Promise(function(resolve, reject) {
        const refreshToken = cookieManager.get('refreshToken');
        if (!refreshToken) {
          // console.log('No refresh token available.');
          reject(new Error('No refresh token available.'));
          logout();
          return;
        } // TODO: use authService
        axios.post(`${process.env.VUE_APP_BASE_URL}/api/token/refresh/`, { refresh: refreshToken },
          { withCredentials: true, headers: { 'Content-Type': 'application/json' } })
          .then(response => {
            if (response.status === 200) {
              // console.log('AccessToken refreshed');
              cookieManager.set('accessToken', response.data.access);
              originalRequest.headers['Authorization'] = 'Bearer ' + response.data.access;
              processQueue(null, response.data.access);
              resolve(axios(originalRequest));
            } else {
              // Anything but 200 is a failed refresh. Without this the promise
              // stayed pending and the caller's request never returned.
              const refreshFailed = new Error(`Token refresh failed with status ${response.status}`);
              logout();
              processQueue(refreshFailed, null);
              reject(refreshFailed);
            }
          })
          .catch((refreshError) => {
            // console.log('Error refreshing token.', refreshError);
            logout();
            processQueue(refreshError, null);
            reject(refreshError);
          })
          .finally(() => {
            isRefreshing = false;
          });
      });
    }
    return Promise.reject(error);
  }
);
